import { SETTINGS as type } from '@/store/types';
import Settings from '@/services/Api/Settings';

const state = {
  data: [],
  loading: false,
};

const mutations = {
  [type.LOADING](state, data) {
    state.loading = data;
  },
  [type.SET](state, data) {
    state.data = data;
  },
  [type.CLEAR]() {
    this.commit(type.SET, []);
  },
};

const actions = {
  async fetchSettings({ commit }) {
    commit(type.LOADING, true);
    return Settings.all()
      .then((response) => {
        const { status, data } = response?.data ?? {};
        if (status === 200) {
          commit(type.SET, data);
        }
      })
      .finally(() => {
        commit(type.LOADING, false);
      });
  },
  setSettings({ commit }, data) {
    commit(type.SET, data);
  },
};

const getters = {
  conferencesEnabled(state) {
    const conferencesEnabled = state.data.find((s) => s.key === 'conferencesEnabled');
    return !!conferencesEnabled?.value;
  },
  budgetTemplateUrl(state) {
    const budgetTemplate = state.data.find((s) => s.key === 'budgetTemplate');
    const value = budgetTemplate?.value;
    if (value && typeof value === 'object') {
      return value.url || null;
    }
    return null;
  },
  currentTriennium(state) {
    const currentTriennium = state.data.find((s) => s.key === 'currentTriennium');
    const value = Number(currentTriennium?.value);

    return Number.isFinite(value) && value > 0
      ? value
      : null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
